export enum WebhookEventStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum WebhookEventStatusName {
  PENDING = 'Pending',
  SUCCESS = 'Success',
  FAILED = 'Failed',
}

export enum WebhookModuleEvent {
  CREATED = 'TL_WEBHOOK_EVENT_CREATED',
}
